import { fetchApi } from '@/common-utilities/fetch-utilities';
import { API_ENDPOINTS } from '@/common-constants/api-constants';

export interface S3DirectoryResponse {
  solution: string;
  region: string;
  prefix: string;
  paths: string[];
}

export interface S3ReadResponse {
  solution: string;
  region: string;
  preSignedUrls: { path: string; url: string | null; error: string | null }[];
}

export async function listDirectory(
  solution: string,
  region: string,
  prefix: string
): Promise<S3DirectoryResponse> {
  const params = new URLSearchParams({ solution, region, prefix });
  const endpoint = `${API_ENDPOINTS.S3_DIRECTORY}?${params.toString()}`;
  const response = await fetchApi<S3DirectoryResponse>(endpoint);
  return response.data;
}

export async function readObjects(
  solution: string,
  region: string,
  paths: string[]
): Promise<S3ReadResponse> {
  const response = await fetchApi<S3ReadResponse>(API_ENDPOINTS.S3_READ, {
    method: 'POST',
    body: { solution, region, paths },
  });
  return response.data;
}

export default {
  listDirectory,
  readObjects,
};
